
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jumpstart-mw-trial",
      function () {
        return require("private-next-pages/jumpstart-mw-trial/index.js");
      }
    ]);
  